import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

export default class Assets {
	constructor() {
		this.signals = {};
		this.signals.complete = new P3.utils.MiniSignal();

		this._modelFiles = [];
		this._textureFiles = [];

		this._assets = new Map();
	}

	addFiles(files) {
		for (const item of files) {
			if (item.type === '3d') {
				this._modelFiles.push(item);
			} else if (item.type === 'texture') {
				this._textureFiles.push(item);
			}
		}
	}

	loadFiles() {
		THREE.DefaultLoadingManager.onLoad = () => {
			this.signals.complete.dispatch(this);
		};

		const gltfloader = new GLTFLoader();

		for (let i = 0; i < this._modelFiles.length; i++) {
			gltfloader.load(
				this._modelFiles[i].path,
				(object) => {
					this._assets.set(this._modelFiles[i].name.toLowerCase(), object.scene);
				}, undefined,
				(error) => {
					console.error(`ERROR LOADING GLTF: ${this._modelFiles[i].path}`, error);

					return false;
				},
			);
		}

		const textureLoader = new THREE.TextureLoader();

		for (let i = 0; i < this._textureFiles.length; i++) {
			textureLoader.load(
				this._textureFiles[i].path,
				(object) => {
					this._assets.set(this._textureFiles[i].name.toLowerCase(), object);
				}, undefined,
				(error) => {
					console.error(`ERROR LOADING TEXTURE: ${this._textureFiles[i].path}`, error);

					return false;
				},
			);
		}
	}

	model(file) {
		const asset = this._assets.get(file.toLowerCase());

		if (asset === undefined) {
			console.error(`[3JS] Asset not found: ${file}\nUsing fallback mesh`);

			const geo = new THREE.BoxGeometry(1, 1, 1);
			const mat = new THREE.MeshBasicMaterial({ color: 0xff00dc });

			return new THREE.Mesh(geo, mat);
		}

		const model = asset.clone().children[0];

		return model;
	}

	texture(file) {
		const asset = this._assets.get(file.toLowerCase());

		if (asset === undefined) {
			console.error(`[3JS] Asset not found: ${file}\nUsing fallback texture`);

			const tex = new THREE.TextureLoader().load('./assets/images/checkerboard.png');

			tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
			tex.magFilter = tex.minFilter = THREE.NearestFilter;

			return tex;
		}

		return asset;
	}

	get assets() {
		return this._assets;
	}

	get spineCache() {
		return this._spineAssets;
	}
}
